import { createContext } from 'react'

import { State } from './GlobalState.type'

export default createContext<State>(null)
